<template>
	<div>
		<div v-if="!loading" layout="column" layout-align="start start" class="full-width pr2-pc pl2-pc pb-2 pr1-mobile pl1-mobile bg-white" flex>
			<div layout="row" layout-align="start center" class="title grey--text text-uppercase font-weight-medium mb2-pc mb1-mobile mt2-pc mt1-mobile full-width">{{$t('surveys.the_survey')}}
				<span flex></span>
				<v-btn @click="$router.push({name: 'surveys-show-survey-preview'})" v-if="survey.questions && survey.questions.length" color="primary" depressed small><v-icon class="mr-2">mdi-eye</v-icon>{{$t('_.preview')}}</v-btn>
			</div>
			<div layout="row" layout-align="center center" class="headline full-width mt2-mobile font-weight-bold">
				{{i18n(survey.title)}}
			</div>
			<div layout="row" layout-align="center center" class="full-width mt-4 mt1-mobile">
				{{i18n(survey.description)}}
			</div>

			<div v-if="!tuto || nbPages()" layout="column" layout-align="center center" class="full-width hidden-sm-and-down">
				<div layout="row" layout-align="center center" class="field-width mb-5 mt-4">
					<div layout="row" layout-align="start center" v-for="(p,i) in survey.pages" :key="'p_' + i" v-if="i != '+'" flex>
						<v-divider :style="'width:' + dividerWidth() + 'px; max-width: ' + dividerWidth() + 'px;'"></v-divider>
						<v-btn @click="currentPage = i" :color="(currentPage == i) ? 'secondary' : '#E0E0E0'" depressed style="width: 80px; height: 80px; font-size: 30px" fab class="mx-0">{{i}}</v-btn>
					</div>
					<v-divider :style="'width:' + dividerWidth() + 'px; max-width: ' + dividerWidth() + 'px;'"></v-divider>
					<div layout="column" layout-align="center center" style="display: block; position: relative">
						<v-menu v-model="pageModal" :close-on-content-click="false" bottom :offset-y="true">
							<v-btn slot="activator" color="#E0E0E0" style="width: 80px; height: 80px" icon class="mx-0"><v-icon size="30">mdi-plus</v-icon></v-btn>
							<v-card style="width: 600px">
								<v-card-text>
									<v-form ref="pageForm" @submit.prevent="addPage">
										<div class="font-weight-bold mt-3">{{$t('surveys.page_title')}}</div>
										<v-text-field v-for="l in survey.langs_ids" :key="'pagetitle_'+l" :label="l.toUpperCase()" v-model="editingPage.title[l]" class="full-width" :rules="[ v => !!v || $t('errors.required') ]" flex></v-text-field>

										<div layout="row" layout-align="end center" class="full-width mt-2 mb-2">
												<v-btn depressed color="secondary" @click="addPage" style="text-transform: none">{{$t('_.add')}}</v-btn>
												&nbsp;{{$t('_.or')}}&nbsp;
												<a href="#" @click.prevent="cancelPage" class="black--text">{{$t('_.cancel')}}</a>
										</div>
									</v-form>
								</v-card-text>
							</v-card>
						</v-menu>

						<span style="position: absolute; color: #E0E0E0; display: block; text-align: center">{{$t('surveys.new_page')}}</span>
					</div>
					<v-divider :style="'width:' + dividerWidth() + 'px; max-width: ' + dividerWidth() + 'px;'"></v-divider>
				</div>
			</div>

			<div v-if="nbPages() && survey.pages[currentPage] && survey.pages[currentPage].title" layout="row" layout-align="center center" class="title full-width font-weight-bold mt2-mobile">
				{{i18n(survey.pages[currentPage].title)}}
				<v-menu v-model="pageDeleteModal" bottom offset-y>
					<v-btn slot="activator" icon class="mx-0"><v-icon color="error">mdi-delete</v-icon></v-btn>
					<v-card style="width: 300px">
						<v-card-text>
							{{$t('surveys.delete_page')}}
							<div layout="row" layout-align="end center" class="full-width mt-2">
									<v-btn depressed color="error" @click="deletePage" style="text-transform: none">{{$t('_.delete')}}</v-btn>
									&nbsp;{{$t('_.or')}}&nbsp;
									<a href="#" @click.prevent="() => {}" class="black--text">{{$t('_.cancel')}}</a>
							</div>
						</v-card-text>
					</v-card>
				</v-menu>
			</div>
			<div v-if="!tuto && nbPages()" layout="row" layout-align="center center" class="full-width mt-1">
				<v-btn @click="currentPage--" icon class="ma-0 pa-0 hidden-md-and-up" :disabled="currentPage == 1"><v-icon>mdi-chevron-left</v-icon></v-btn>{{totalQuestionsPast()}} / {{totalQuestions()}}<v-btn @click="currentPage++" icon class="ma-0 pa-0 hidden-md-and-up" :disabled="currentPage == nbPages()"><v-icon>mdi-chevron-right</v-icon></v-btn>
			</div>

			<div v-if="!tuto"  layout="row" layout-align="center center" class="hidden-md-and-up full-width">
				<v-menu v-model="pageModalM" :close-on-content-click="false" full-width min-width="93%" max-width="95%" bottom left :offset-x="true" :offset-y="true">
					<v-btn slot="activator" color="#E0E0E0" icon class="mx-0"><v-icon>mdi-plus</v-icon></v-btn>
					<v-card style="width: 100%">
						<v-card-text>
							<v-form ref="pageForm" @submit.prevent="addPage">
								<div class="font-weight-bold mt-3">{{$t('surveys.page_title')}}</div>
								<v-text-field v-for="l in survey.langs_ids" :key="'pagetitle_'+l" :label="l.toUpperCase()" v-model="editingPage.title[l]" class="full-width" :rules="[ v => !!v || $t('errors.required') ]" flex></v-text-field>

								<div layout="row" layout-align="end center" class="full-width mt-2 mb-2">
										<v-btn depressed color="secondary" @click="addPage" style="text-transform: none">{{$t('_.add')}}</v-btn>
										&nbsp;{{$t('_.or')}}&nbsp;
										<a href="#" @click.prevent="cancelPage" class="black--text">{{$t('_.cancel')}}</a>
								</div>
							</v-form>
						</v-card-text>
					</v-card>
				</v-menu>
			</div>

			<div v-if="tuto" layout="column" layout-align="center center" class="full-width mt-5">
				<div layout="column" layout-align="center center"  class="field-width pa-3" style="background-color: #F5F5F5">
					<v-icon :size="$vuetify.breakpoint. smAndDown ? 100 : 200" color="#BDBDBD">mdi-help-circle</v-icon>
					<div class="title">{{$t('surveys.first_survey')}}</div>
					<div v-if="!nbPages() && !noPage" layout="column" layout-align="center center" style="width: 80%">
						<div class="font-weight-bold mt-4 mb-3">1. {{$t('surveys.the_pages')}}</div>
						<div class="text-xs-center">{{$t('surveys.pages_hint')}}</div>
						<div layout="row" layout-align="center center" class="mt-4" style="width: 80%">
							<v-divider></v-divider>
							<v-menu v-model="pageModal2" :close-on-content-click="false"
							:offset-y="true" :nudge-left="$vuetify.breakpoint. smAndDown ? 0 : 422" :min-width="$vuetify.breakpoint. smAndDown ? '93%' : 0" :offset-x="true" :left="$vuetify.breakpoint. smAndDown ? true : false" bottom>
								<v-btn slot="activator" color="secondary" class="mx-0" icon><v-icon>mdi-plus</v-icon></v-btn>
								<v-card class="popover-width">
									<v-card-text>
										<v-form ref="pageForm" @submit.prevent="addPage">
											<div class="font-weight-bold mt-3">{{$t('surveys.page_title')}}</div>
											<v-text-field v-for="l in survey.langs_ids" :key="'pagetitle_'+l" :label="l.toUpperCase()" v-model="editingPage.title[l]" class="full-width" :rules="[ v => !!v || $t('errors.required') ]" flex></v-text-field>

											<div layout="row" layout-align="end center" class="full-width mt-2 mb-2">
													<v-btn depressed color="secondary" @click="addPage" style="text-transform: none">{{$t('_.add')}}</v-btn>
													&nbsp;{{$t('_.or')}}&nbsp;
													<a href="#" @click.prevent="cancelPage" class="black--text">{{$t('_.cancel')}}</a>
											</div>
										</v-form>
									</v-card-text>
								</v-card>
							</v-menu>
							<v-divider></v-divider>
						</div>
						<div layout="row" layout-align="center center" class="full-width mt-2">
							<a href="#" @click.prevent="noPage = true">{{$t('surveys.no_page')}}</a>
						</div>
					</div>
					<div v-else-if="!survey.pages[currentPage].questions.length" layout="column" layout-align="center center" style="width: 80%">
						<div class="font-weight-bold mt-4 mb-3">2. {{$t('surveys.the_questions')}}</div>
						<div class="text-xs-center">{{$t('surveys.questions_hint')}}</div>
						<v-menu v-model="questionModal2" :close-on-content-click="false" :offset-y="true" :nudge-left="$vuetify.breakpoint. smAndDown ? 0 : 462" :min-width="$vuetify.breakpoint. smAndDown ? '93%' : 0" :offset-x="true" :left="$vuetify.breakpoint. smAndDown ? true : false" bottom>
							<div slot="activator" @click="newQuestion(radio)" layout="column" layout-align="center center" class="mt-2 mb-3 full-width">
								<v-btn color="secondary" icon><v-icon>mdi-plus</v-icon></v-btn>
								{{$t('surveys.add_question')}}
							</div>
							<v-card class="popover-width">
								<v-card-text layout="column" layout-align="center center">
									<v-form v-if="questionStep == 1" ref="questionForm" layout="row" layout-align="center center" class="full-width">
										<div layout="column" class="full-width">
											<div class="font-weight-bold mt-2 mb-3">{{$t('surveys.question_name')}}</div>
											<v-text-field v-for="l in survey.langs_ids" :key="'questionname_'+l" :label="l.toUpperCase()" v-model="editingQuestion.label[l]" class="ml-1 full-width" :rules="[ v => !!v || $t('errors.required') ]" flex></v-text-field>

											<v-checkbox v-model="editingQuestion.is_required" :false-value="0" :true-value="1" :label="$t('surveys.is_required')" class="my-0 py-0 mt-2 ml-1"></v-checkbox>
										</div>
									</v-form>
									<div v-else-if="questionStep == 2" class="full-width">
										<div class="font-weight-bold mt-2 mb-3">{{$t('surveys.question_type')}}</div>
										<div layout="row" layout-align="start start" class="full-width">
											<div v-for="t in questionTypes" @click="editingQuestion.type = t.value" layout="column" layout-align="center center" :key="'qt_' + t.value" class="clickable  question-type text-xs-center pa-2" :class="[(editingQuestion.type == t.value) ? 'type-selected' : '']" flex>
												<v-icon size="60">mdi-{{t.icon}}</v-icon>
												<p flex>{{t.text}}</p>
											</div>
										</div>
										<p v-if="editingQuestion.type" class="mt-3">
											<b>{{questionTypeLabel(editingQuestion.type)}}</b> : {{questionTypeDetails(editingQuestion.type)}}
										</p>
									</div>
									<div v-else-if="questionStep == 3" class="full-width">
										<div v-if="editingQuestion.type == text || editingQuestion.type == textarea">
											<div class="font-weight-bold mt-2 mb-3">{{$t('surveys.question_desc')}}</div>
											<v-text-field v-for="l in survey.langs_ids" :key="'questiondesc_'+l" :label="l.toUpperCase()" v-model="editingQuestion.description[l]" class="full-width" flex></v-text-field>
										</div>
										<div v-else class="mb-3">
											<div class="font-weight-bold mt-2 mb-3">{{$t('surveys.options')}}</div>
											<draggable v-model="editingQuestion.options">
												<div v-for="(o,i) in editingQuestion.options" :key="'opt3_' + i" layout="row" layout-align="start center">
													<div layout="column" layout-align="center start" class="mx-2" style="width: 1em; cursor: move">
														{{i + 1}}.
													</div>
													<div layout="column" layout-align="center end" flex>
														<v-text-field v-for="l in survey.langs_ids" :ref="'editingoption_'+i" :key="'optionlabel_'+l" :label="l.toUpperCase()" v-model="o.label[l]" class="full-width" flex></v-text-field>
													</div>
													<div layout="column" layout-align="center start" class="mx-2 mx1-mobile">
														<v-btn @click="deleteOption(i, null)" icon><v-icon color="grey" class="px-0 mx-0">mdi-close</v-icon></v-btn>
													</div>
												</div>
											</draggable>
											<a href="#" @click.prevent="addOption(null)" class="ml-2">{{$t('surveys.add_option')}}</a>
										</div>
									</div>
									<div layout="row" layout-align="start center" class="full-width mt-2">
											<v-btn v-if="questionStep != 1" depressed color="transparent" @click="questionStep--" style="text-transform: none; color: grey"><v-icon class="mr-1" color="grey">mdi-chevron-left</v-icon>{{$t('surveys.prev')}}</v-btn>
											<span flex></span>
											<v-btn depressed color="secondary" @click="(questionStep == 3) ? saveQuestion() : ($refs['questionForm'] ? ($refs['questionForm'].validate() && questionStep++) : questionStep++)" style="text-transform: none">{{$t('surveys.continue')}}</v-btn>
									</div>
								</v-card-text>
							</v-card>
						</v-menu>
					</div>

					<div layout="row" layout-align="end center" class="full-width mt-5">
						<a href="#" @click.prevent="hideTuto">{{$t('surveys.no_help')}}</a>
					</div>
				</div>
			</div>

			<div layout="column" layout-align="center center" class="full-width mt-4">
				<div v-if="survey.pages && survey.pages[currentPage] && survey.pages[currentPage].questions" class="field-width">
					<div v-for="(q,i) in survey.pages[currentPage].questions" :key="'q_' + i" layout="column" style="background-color: #E8F8F7" layout-align="start start" class="py-3 pl-3 pr-2 full-width mb-3">
						<div layout="row" layout-align="start start" class="full-width">
							<div layout="column" layout-align="center start">
								<div class="font-weight-bold mb-2">{{questionNumber(i)}}. {{i18n(q.label)}} <span v-if="q.is_required" class="orange--text">*</span></div>
							</div>
							<span flex></span>
							<v-menu v-model="menu[i]" :ref="'menuquestion' + i" :nudge-right="40" origin="top right" lazy
									transition="scale-transition" offset-y full-width>
									<v-btn slot="activator" flat depressed light color="transparent" small class="ma-0 pa-0 mr-1" style="min-width: fit-content;">
											<span v-if="!$vuetify.breakpoint. smAndDown" class="message-btn ma-0 light-blue lighten-5"></span>
											<span v-if="!$vuetify.breakpoint. smAndDown" class="message-btn ma-0 ml-1 cyan"></span>
											<span v-if="!$vuetify.breakpoint. smAndDown" class="message-btn ma-0 ml-1 secondary"></span>
											<v-icon v-if="$vuetify.breakpoint. smAndDown" color="black">mdi-dots-vertical</v-icon>
									</v-btn>
									<v-list>
											<v-list-tile
											v-for="(item, index) in menuList"
											:key="index"
											@click="item.action(q,i)"
											>
											<v-list-tile-action style="min-width: auto">
											<v-icon :color="item.color ? item.color : 'black'" class="mr-2">mdi-{{item.icon}}</v-icon>
											</v-list-tile-action>

											<v-list-tile-content>
											<v-list-tile-title v-text="item.title" :class="[item.text ? item.text + '--text' : '']"></v-list-tile-title>
											</v-list-tile-content>
											</v-list-tile>
									</v-list>
							</v-menu>
						</div>
						<v-textarea v-if="q.type == textarea" :placeholder="i18n(q.description)" readonly class="full-width" flex></v-textarea>
						<v-text-field v-else-if="q.type == text" :placeholder="i18n(q.description)" readonly class="full-width" flex></v-text-field>
						<div v-else class="full-width">
							<draggable @change="onDrag(q)" v-model="q.options">
								<div v-for="(o,j) in q.options" :key="'opt2_' + j" layout="row" layout-align="start center">
									<div layout="column" layout-align="center start" class="mx-2" style="width: 1em; cursor: move">
										{{j + 1}}.
									</div>
									<div layout="column" layout-align="center end" flex>
										<v-text-field v-for="l in survey.langs_ids" @blur="saveOption(o,j)" :ref="'option_'+i+j" :key="'optionlabel_'+l" :label="l.toUpperCase()" v-model="o.label[l]" class="full-width" flex></v-text-field>
									</div>
									<div layout="column" layout-align="center start" class="mx-2 mx1-mobile">
										<v-btn @click="deleteOption(j,i)" icon><v-icon color="grey" class="px-0 mx-0">mdi-close</v-icon></v-btn>
									</div>
								</div>
							</draggable>
							<a href="#" @click.prevent="addOption(i)" class="ml-2">{{$t('surveys.add_option')}}</a>
						</div>
					</div>
				</div>

				<v-form ref="questionForm" id="question-form" v-if="isEditingQuestion && !tuto" layout="row" layout-align="center center" class="field-width">
					<div layout="column" class="full-width">
						<div layout="row" layout-align="start center" class="subheading grey--text text-uppercase font-weight-medium mb2-pc mb1-mobile mt3-pc mt1-mobile">{{ editingQuestion.number ? $t('surveys.edit_question') : $t('surveys.new_question') }} ({{questionTypeLabel(editingQuestion.type)}})</div>

						<div class="font-weight-bold mt-3">{{$t('surveys.question_name')}}</div>
						<v-text-field v-for="l in survey.langs_ids" :key="'questionname_'+l" :label="l.toUpperCase()" v-model="editingQuestion.label[l]" class="full-width" :rules="[ v => !!v || $t('errors.required') ]" flex></v-text-field>

						<v-checkbox v-model="editingQuestion.is_required" :false-value="0" :true-value="1" :label="$t('surveys.is_required')" class="my-0 py-0 mt-2"></v-checkbox>

						<div v-if="editingQuestion.type == text || editingQuestion.type == textarea">
							<div class="font-weight-bold mt-3">{{$t('surveys.question_desc')}}</div>
							<v-text-field v-for="l in survey.langs_ids" :key="'questiondesc_'+l" :label="l.toUpperCase()" v-model="editingQuestion.description[l]" class="full-width" flex></v-text-field>
						</div>
						<div v-else>
							<div class="font-weight-bold mt-3">{{$t('surveys.options')}}</div>
							<draggable v-model="editingQuestion.options">
								<div v-for="(o,i) in editingQuestion.options" :key="'opt_' + i" layout="row" layout-align="start center">
									<div layout="column" layout-align="center start" class="mx-2" style="width: 1em; cursor: move">
										{{i + 1}}.
									</div>
									<div layout="column" layout-align="center end" flex>
										<v-text-field v-for="l in survey.langs_ids" :ref="'editingoption_'+i" :key="'optionlabel_'+l" :label="l.toUpperCase()" v-model="o.label[l]" class="full-width" flex></v-text-field>
									</div>
									<div layout="column" layout-align="center start" class="mx-2 mx1-mobile">
										<v-btn @click="deleteOption(i, null)" icon><v-icon color="grey" class="px-0 mx-0">mdi-close</v-icon></v-btn>
									</div>
								</div>
							</draggable>
							<a href="#" @click.prevent="addOption(null)" class="ml-2">{{$t('surveys.add_option')}}</a>
						</div>

						<div layout="row" layout-align="end center" class="full-width mt-2 mb-2">
								<v-btn depressed color="secondary" @click="saveQuestion" style="text-transform: none">{{ editingQuestion.number ? $t('_.edit') : $t('_.add')}}</v-btn>
								&nbsp;{{$t('_.or')}}&nbsp;
								<a href="#" @click.prevent="cancelQuestion" class="black--text">{{$t('_.cancel')}}</a>
						</div>
					</div>
				</v-form>
				<div layout="row" layout-align="start start" class="field-width">
					<v-menu v-if="!isEditingQuestion && !tuto" v-model="questionModal" offset-x>
						<div slot="activator" layout="column" layout-align="center center" class="mt-2 mb-3">
							<v-btn color="secondary" icon><v-icon>mdi-plus</v-icon></v-btn>
							{{$t('surveys.add_new_question')}}
						</div>
						<v-card>
							<v-card-text layout="column" layout-align="center center">
								<div v-for="t in questionTypes" :key="'qt2_' + t.value" @click="newQuestion(t.value); questionModal = false" layout="column" layout-align="center center" class="clickable full-width question-type mt-2">
									<v-icon size="40">mdi-{{t.icon}}</v-icon>
									{{t.text}}
								</div>
							</v-card-text>
						</v-card>
					</v-menu>
				</div>
			</div>
<!--
			<div layout="column" layout-align="center center" class="full-width mt-5">
				<div layout="row" layout-align="end center" class="field-width width-95-mobile">
						<v-btn depressed color="secondary" @click="save" style="text-transform: none">{{$t('_.save')}}</v-btn>
						&nbsp;{{$t('_.or')}}&nbsp;
						<router-link :to="{name: 'surveys-show-info'}" class="grey--text">{{$t('_.cancel')}}</router-link>
				</div>
			</div>
-->
		</div>
		<div layout="row" class="bg-white" style="height: 100%" layout-align="center center" v-else>
				<v-progress-circular indeterminate color="secondary" size="64"></v-progress-circular>
		</div>
	</div>
</template>
<script>
    import Consts from '@/consts'
    import I18nMixin from '@/mixins/i18n'
		import draggable from 'vuedraggable'
		import Surveys from '@/api/surveys'
		import Auth from '@/plugins/auth'
		import EventBus from '@/plugins/eventbus'

    export default {
				components: {
            draggable,
        },
        mixins: [I18nMixin],
        props: {
            survey: {
                required: true,
                type: Object,
								default () {
									return {message: {}};
								}
            }
        },
        data () {
            return {
							currentPage: '+',
							questionModal: false,
							questionModal2: false,
							questionStep: 1,
							pageModal: false,
							pageModal2: false,
							pageModalM: false,
							isEditingQuestion: false,
							editingQuestion: {
								is_required: false,
								description: {},
								label: {},
								options: [],
								id: null,
								page_id: null
							},
							editingPage: {
								title: {},
								number: null,
								questions: [],
								id: null
							},
							menu: [],
							loading: false,
							tuto: false,
							noPage: false,
							pageDeleteModal: false
            }
        },
        mounted () {
					if(this.nbPages()){
						this.currentPage = 1;
					} else{
						if(!this.survey.pages['+'].questions || !this.survey.pages['+'].questions.length){
							if(!Auth.user.skip_tuto){
								this.tuto = true;
							}
						}
					}
        },
        methods: {
					addPage(){
						if (!this.$refs['pageForm'].validate()) {
								return;
						}

						this.editingPage.number = Object.keys(this.survey.pages).length;

						Surveys.createPage(this.survey.id, this.editingPage).then((res) => {
								this.editingPage.id = res.data.id;
								this.survey.pages[Object.keys(this.survey.pages).length] = JSON.parse(JSON.stringify(this.editingPage));
								this.currentPage = (Object.keys(this.survey.pages).length - 1);
								this.cancelPage();
						})
					},
					deletePage(){
						const num = this.currentPage;
						Surveys.deletePage(this.survey.id, this.survey.pages[num].id).then(() => {
								delete this.survey.pages[num];
								let arr = [];
								for(let p in this.survey.pages){
									if(p != '+' && p > num){
										arr.push(p);
									}
								}
								for(let i = 0; i < arr.length; i++){
									const n = arr[i];
									this.survey.pages[n].number = (n - 1);
									Surveys.updatePage(this.survey.id, this.survey.pages[n].id, this.survey.pages[n]).then(() => {
											this.survey.pages[(n - 1)] = this.survey.pages[n];
											delete this.survey.pages[n];
											this.survey.pages = Object.assign({}, this.survey.pages);
									})
								}

								if(this.nbPages()){
									this.currentPage = 1;
								} else{
									this.currentPage = '+';
								}
						})
					},
					cancelPage(){
						this.editingPage.id = null;
						this.editingPage.title = {};
						this.editingPage.questions = [];
						this.editingPage.number = null;

						this.$nextTick(() => {
							this.$refs.pageForm.resetValidation();
							this.pageModal = false;
							this.pageModal2 = false;
							this.pageModalM = false;
						})
					},
					newQuestion(type){
						this.questionStep = 1;
						this.editingQuestion = {
							type : type,
							label: {},
							description:  {},
							is_required: 0,
							options: [],
							id: null,
							page_id: (this.currentPage == '+') ? null : this.survey.pages[this.currentPage].id
						};

						if(type == this.checkbox || type == this.radio){
							this.addOption(null, false);
						}

						this.isEditingQuestion = true;

						this.$nextTick(() => {
							this.$refs['questionForm'].reset();
						})
					},
					editQuestion(q){
						this.editingQuestion = Object.assign({}, JSON.parse(JSON.stringify(q)));
						this.isEditingQuestion = true;

						this.$nextTick(() => {
							let a = document.createElement("a");
							document.body.appendChild(a);
							a.style = "display: none";
							a.href = "#question-form";
							a.click();
						})
					},
					saveQuestion(){
						if (this.$refs['questionForm'] && !this.$refs['questionForm'].validate()) {
								return;
						}

						if(this.editingQuestion.id){//Edit
						const pos = this.editingQuestion.number - 1;//Num relatif à la page
						this.editingQuestion.number = this.questionNumber(this.editingQuestion.number - 1);//Num par rapport à l'enquête
							Surveys.updateQuestion(this.survey.id, this.editingQuestion.id, this.editingQuestion).then(() => {
								this.survey.pages[this.currentPage].questions[pos] = JSON.parse(JSON.stringify(this.editingQuestion));

								for(let i = 0; i < this.survey.pages[this.currentPage].questions[pos].options.length; i++){
									this.saveOption(this.survey.pages[this.currentPage].questions[pos].options[i], i);
								}

								this.editingQuestion = {
									label: {},
									description:  {},
									is_required: 0,
									options: [],
									page_id: null,
									id: null
								};

								if(this.$refs['questionForm']){
									this.$refs['questionForm'].reset();
								}
								this.isEditingQuestion = false;
								this.tuto = false;
							})
						} else{//Add
							this.editingQuestion.number = this.questionNumber(this.survey.pages[this.currentPage].questions.length);

							Surveys.createQuestion(this.survey.id, this.editingQuestion).then((res) => {
								this.editingQuestion.id = res.data.id;
								this.survey.pages[this.currentPage].questions.push(JSON.parse(JSON.stringify(this.editingQuestion)));

								const pos = this.survey.pages[this.currentPage].questions.length - 1;

								for(let i = 0; i < this.survey.pages[this.currentPage].questions[pos].options.length; i++){
									this.survey.pages[this.currentPage].questions[pos].options[i].question_id = res.data.id;
									this.saveOption(this.survey.pages[this.currentPage].questions[pos].options[i], i);
								}

								this.editingQuestion = {
									label: {},
									description:  {},
									is_required: 0,
									options: [],
									page_id: null,
									id: null
								};

								if(this.$refs['questionForm']){
									this.$refs['questionForm'].reset();
								}
								this.isEditingQuestion = false;
								this.tuto = false;
							})
						}
					},
					cancelQuestion(){
						this.editingQuestion = {
							label: {},
							description:  {},
							is_required: 0,
							options: [],
							id: null,
							page_id: null
						}
						this.$refs['questionForm'].reset();
						this.isEditingQuestion = false;
					},
					deleteQuestion(i){
						Surveys.deleteQuestion(this.survey.id, this.survey.pages[this.currentPage].questions[i].id).then(() => {
								this.survey.pages[this.currentPage].questions.splice(i, 1);
								this.survey.pages = Object.assign({}, this.survey.pages);
						})
					},
					onDrag(q){
						for(let i = 0; i < q.options.length; i++){
							this.saveOption(q.options[i], i);
						}
					},
					saveOption(o, i){
						o.position = i + 1;
						if(o.id){
							Surveys.updateOption(this.survey.id, o.question_id, o.id, o).then(() => {

							})
						} else{
							Surveys.createOption(this.survey.id, o.question_id, o).then((res) => {
								o.id = res.data.id;
							})
						}
					},
					addOption(i  = null, focus = true){
						if(i != null){
							this.survey.pages[this.currentPage].questions[i].options.push({
								label: {},
								position: null,
								id: null,
								question_id: this.survey.pages[this.currentPage].questions[i].id
							});
							this.survey.pages = Object.assign({}, this.survey.pages);
							this.$nextTick(() => {
								this.$refs['option_' + i + (this.survey.pages[this.currentPage].questions[i].options.length - 1)][0].focus();
							})
						} else{
							this.editingQuestion.options.push({
								label: {},
								position: null,
								id: null,
								question_id: this.editingQuestion.id ? this.editingQuestion.id : null
							});
							if(focus){
								this.$nextTick(() => {
									this.$refs['editingoption_' + (this.editingQuestion.options.length - 1)][0].focus();
								})
							}
						}
					},
					deleteOption(i, q = null){
						if(q != null){
							Surveys.deleteOption(this.survey.id, this.survey.pages[this.currentPage].questions[q].id, this.survey.pages[this.currentPage].questions[q].options[i].id).then(() => {
								this.survey.pages[this.currentPage].questions[q].options.splice(i, 1);
								this.survey.pages = Object.assign({}, this.survey.pages);
							})
						} else{
							this.editingQuestion.options.splice(i, 1);
						}
					},
					questionTypeLabel(t){
							switch (t) {
									case Consts.RADIO:
											return this.$t('surveys.choices_list');
									case Consts.CHECKBOX:
											return this.$t('surveys.choices_list_mul');
									case Consts.TEXT:
											return this.$t('surveys.short_answer');
									case Consts.TEXTAREA:
											return this.$t('surveys.long_answer');
							}
					},
					questionTypeDetails(t){
							switch (t) {
									case Consts.RADIO:
											return this.$t('surveys.cl_hint');
									case Consts.CHECKBOX:
											return this.$t('surveys.clm_hint');
									case Consts.TEXT:
											return this.$t('surveys.sa_hint');
									case Consts.TEXTAREA:
											return this.$t('surveys.ta_hint');
							}
					},
					nbPages(){
						return (Object.keys(this.survey.pages).length - 1);
					},
					dividerWidth (){
						return (900 - (80 * Object.keys(this.survey.pages).length)) / (Object.keys(this.survey.pages).length + 1);
					},
					questionNumber(i){
						let n = 0;
						for(let p in this.survey.pages){
							if(p < this.currentPage && p != '+'){
								n += this.survey.pages[p].questions.length;
							}
						}

						if(this.survey.pages[this.currentPage].questions[i]){
							this.survey.pages[this.currentPage].questions[i].number = (i + 1);
						}

						return (n + i + 1);
					},
					save(){
						this.loading = true;
						if(this.nbPages()){//On divise l'enquête en plusieurs voleys
							delete this.survey.pages['+'];
							for(let p in this.survey.pages){
								this.survey.pages[p].number = p;
								for(let i = 0; i < this.survey.pages[p].questions.length; i++){
									this.currentPage = p;
									this.survey.pages[p].questions[i].number = this.questionNumber(i);
									for(let j = 0; j < this.survey.pages[p].questions[i].options.length; j++){
										this.survey.pages[p].questions[i].options[j].position = (j + 1);
									}
								}
							}
						}
						else{//On renvoie directement toutes les questions
							this.survey.questions = this.survey.pages['+'].questions;
							for(let i = 0; i < this.survey.questions.length; i++){
								this.survey.questions[i].number = (i + 1);
								for(let j = 0; j < this.survey.questions[i].options.length; j++){
									this.survey.questions[i].options[j].position = (j + 1);
								}
							}
							delete this.survey.pages;
						}

						Surveys.updateForm(this.survey.id, this.survey).then(() => {
							this.loading = false;
							EventBus.$emit('survey-updated');
							this.$router.push({name: 'surveys-show-info'});
							this.$snotify.success(this.$t('surveys.edited'));
						}, () => {
							this.loading = false;
						})
					},
					hideTuto(){
						this.tuto = false;
						this.$store.commit('SET_TUTO');
					},
					totalQuestions(){
						let n = 0;
						for(let p in this.survey.pages){
							if(p != '+'){
								n += this.survey.pages[p].questions.length;
							}
						}

						return n;
					},
					totalQuestionsPast(){
						let n = 0;
						for(let p in this.survey.pages){
							if(p <= this.currentPage && p != '+'){
								n += this.survey.pages[p].questions.length;
							}
						}

						return n;
					},
        },
        computed: {
					questionTypes () {
							return [
									{ value: Consts.RADIO, text: this.$t('surveys.choices_list'), icon: 'format-list-bulleted' },
									{ value: Consts.CHECKBOX, text: this.$t('surveys.choices_list_mul'), icon: 'format-list-bulleted-square' },
									{ value: Consts.TEXT, text: this.$t('surveys.short_answer'), icon: 'format-text-variant' },
									{ value: Consts.TEXTAREA, text: this.$t('surveys.long_answer'), icon: 'format-letter-case' },
							]
					},
					text(){
						return Consts.TEXT;
					},
					textarea(){
						return Consts.TEXTAREA;
					},
					checkbox(){
						return Consts.CHECKBOX;
					},
					radio(){
						return Consts.RADIO;
					},
					menuList(){
						return [
							{
									title: this.$t('surveys.edit_question'),
									icon: 'pencil',
									action: (q) => this.editQuestion(q)
							},
							{
									title: this.$t('surveys.delete_question'),
									icon: 'delete',
									color: 'red',
									text: 'red',
									action: (q,i) => this.deleteQuestion(i)
							}
						]
					},
        }
    }
</script>
<style>
</style>
<style scoped>
.type-selected,
.question-type:hover {
  background-color: #f5f5f5;
}

.message-btn {
  height: 14px;
  width: 14px;
  border: 1px;
  border-radius: 50% 50%;
}
</style>